import React from "react";

type AiFieldHeaderProps = {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  hint?: string;
};

export function AiFieldHeader({ label, onClick, disabled, loading, hint }: AiFieldHeaderProps) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 12,
        marginBottom: 6,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <span className="label" style={{ margin: 0 }}>
          {label}
        </span>
        {hint ? (
          <span style={{ fontSize: 12, color: "#9aa3b2" }}>{hint}</span>
        ) : null}
      </div>

      <button
        type="button"
        onClick={onClick}
        disabled={disabled || loading}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          padding: "6px 12px",
          borderRadius: 999,
          border: "1px solid rgba(255,255,255,0.12)",
          background: disabled || loading ? "#555" : "linear-gradient(to right, #A447FF, #FF5CC4)",
          color: "#fff",
          fontSize: 13,
          cursor: disabled || loading ? "not-allowed" : "pointer",
          boxShadow: disabled || loading ? "none" : "0 8px 18px rgba(164,71,255,0.22)",
        }}
        title={disabled ? "請先上傳檔案/附件" : "AI 產生草稿"}
      >
        <span style={{ opacity: loading ? 0.85 : 1 }}>{loading ? "AI 生成中…" : "✨ AI 產生草稿"}</span>
      </button>
    </div>
  );
} 

